<div class="orders-container">
  <div class="orders-body">
    <router-outlet />
  </div>
</div>
